import React from "react";
import styles from "./FeaturedTermSettings.module.scss";
import { SonicTermData } from "../../../../common/classes/SonicTerm";
import { getDefaultImage } from "../../../../utils/GeneralUtils";

type Props = {
  selectedTerm?: SonicTermData;
};
const FeaturedTermSettingsItem: React.FC<Props> = ({ selectedTerm }) => {
  if (selectedTerm) {
    return (
      <li className={styles["featured-term-settings__list__item"]}>
        <div
          className={`${styles["featured-term-settings__list__item__box"]} ${styles["imgBox"]}`}
        >
          <img
            src={
              selectedTerm.img ? selectedTerm.img.large.url : getDefaultImage()
            }
          />
        </div>
        <div className={styles["featured-term-settings__list__item__name"]}>
          {selectedTerm.name}
        </div>
      </li>
    );
  } else {
    return (
      <li className={styles["featured-term-settings__list__item"]}>
        <div
          className={`${styles["featured-term-settings__list__item__box"]} ${styles["no-img"]}`}
        ></div>
        <div className={styles["featured-term-settings__list__item__name"]}>
          {"選択していません"}
        </div>
      </li>
    );
  }
};

export default FeaturedTermSettingsItem;
